<div [class.expanded]="toggled && !error" class="video">
    @if (!toggled) {
        <img (tap)="toggleVideo()" [src]="videoCollapsedIconUrl" alt="Video"
             class="video-button grow"/>
    }

    @if (toggled) {
        <div (tap)="toggleVideo()" class="video-button">
            <i aria-hidden="true" class="fa fa-times close-icon"></i>
        </div>
    }


    @if (toggled && !clickedOnImage) {
        <div (tap)="showVideo()" class="preview-container">
            <img (tap)="showVideo()" [attr.src]="videoImageUrl" alt="Video Vorschaubild"/>
        </div>
    }


    @if (toggled && clickedOnImage) {
        <iframe [attr.alt]="video.content || 'Video'"
                [attr.src]="iFrameUrl" allowfullscreen class="iframe" frameborder="0">
        </iframe>
    }

</div>